import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import FilterTopbar from 'components/search_page/filter_topbar';

import { delayRetrieveRecords, retrieveRecords } from '../store/actions/search';

import RequirementsCurrentFiltersGroup from './current_filters_group';
import FilterRow from './filter_row';
import Filters from './filters';

export class FilterTopBar extends React.Component {
  static propTypes = {
    delayRetrieveRecords: PropTypes.func,
    retrieveRecords: PropTypes.func.isRequired
  };

  componentDidMount() {
    const { retrieveRecords } = this.props;
    retrieveRecords();
  }

  render() {
    return (
      <FilterTopbar>
        <div>{this.renderFilters()}</div>
        <div className="d-none d-md-block">
          <div className="ms-3 container-fluid">
            <RequirementsCurrentFiltersGroup />
          </div>
        </div>
      </FilterTopbar>
    );
  }

  renderFilters() {
    return (
      <FilterRow>
        <Filters />
      </FilterRow>
    );
  }
}

const mapDispatchToProps = {
  delayRetrieveRecords,
  retrieveRecords
};

export default connect(() => ({}), mapDispatchToProps)(FilterTopBar);
